import React from 'react';
import { Link } from 'react-router-dom';
import EmailSender from './EmailSender';

const Footer = () => {
  return (
    <>
      <footer className="footer bg-gray-200">
        <div className="container flex items-center justify-between flex flex-col md:flex-row md:items-center gap-3 md:gap-10">

          <div className="mb-10">
            <a
              href="https://www.camara-arequipa.org.pe/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Ir a la web de la Cámara de Comercio e Industria de Arequipa"
            >
              <img src="/logo_ccia.webp" alt="Cámara de Comercio e Industria de Arequipa" className="logo_footer" width="3642" height="1176" decoding="async" />
            </a>
          </div>

          <div className="center flex flex-col md:flex-row md:items-center gap-3 md:gap-10 lg:gap-10">
            <div className="footer-column">
              <h2 className="footer-text">Dirección</h2>
              <ul>
                <li className='footer-text-small'>Quezada 104,</li>
                <li className='footer-text-small'>Yanahuara, Arequipa</li>
              </ul>
            </div>
            <div className="footer-column">
              <h2 className="footer-text">Publicidad</h2>
              <ul>
                <li className='footer-text-small'>
                  <a
                    className="footer-telefono"
                    href="https://wa.me/51902552940"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Escribir por WhatsApp al 902 552 940"
                  >
                    902 552 940
                  </a>
                </li>
                <li className='footer-text-small'>
                  <a
                    className="footer-telefono"
                    href="https://wa.me/51958313928"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Escribir por WhatsApp al 958 313 928"
                  >
                    958 313 928
                  </a>
                </li>
                <li className='footer-text-small'>
                  <a
                    className="footer-telefono"
                    href="mailto:revistacamaraaqp@cciarequipa.org"
                  >
                    revistacamaraaqp@cciarequipa.org
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h2 className="footer-text">Nosotros</h2>
              <ul>
                <li className='footer-text-small'><Link to="/nosotros">Nosotros</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <EmailSender />


        <hr className="border-t-2 border-gray-300" />

        <div className="text-center text-gray-600">
          <p className='footer-text-small'>© {new Date().getFullYear()} Cámara de Comercio e Industria de Arequipa®</p>
        </div>
      </footer>



    </>
  );
};

export default Footer;
